(function () {
	const getSwiperElement = (section) => section.querySelector('.swiper--multicolumn');

	const initSlider = (section) => {
		const swiperElement = getSwiperElement(section);

		if (!swiperElement || swiperElement.multicolumnSwiper) return;

		swiperElement.classList.add('multicolumn-swiper-wrapper');

		swiperElement.querySelectorAll('.multicolumn-list__item').forEach((slide) => {
			slide.classList.add('swiper-slide');
		});

		const pagination = swiperElement.querySelector('.multicolumn-pagination');
		const swiperParams = {
			loop: false,
			slidesPerView: 2,
			slidesPerGroup: 1,
			spaceBetween: 0,
			watchOverflow: true,
		};

		if (pagination) {
			swiperParams.pagination = {
				el: pagination,
				clickable: true,
			};
		}

		swiperElement.multicolumnSwiper = new Swiper(swiperElement, swiperParams);
	};

	const destroySlider = (section) => {
		const swiperElement = getSwiperElement(section);
		const swiper = swiperElement && swiperElement.multicolumnSwiper;

		if (!swiper) return;

		swiper.destroy(true, true);
		delete swiperElement.multicolumnSwiper;

		swiperElement.classList.remove('multicolumn-swiper-wrapper');
		swiperElement.querySelectorAll('.multicolumn-list__item').forEach((slide) => {
			slide.removeAttribute('style');
			slide.classList.remove('swiper-slide');
		});
	};

	const updateSlider = (section) => {
		if (!getSwiperElement(section)) return;

		if (section.getBoundingClientRect().width < 990) {
			initSlider(section);
		} else {
			destroySlider(section);
		}
	};

	const setupSection = (section) => {
		if (!section) return;

		if (section.multicolumnResizeObserver) {
			updateSlider(section);
			return;
		}

		const observer = new ResizeObserver(() => updateSlider(section));
		observer.observe(section);
		section.multicolumnResizeObserver = observer;
		updateSlider(section);
	};

	const teardownSection = (section) => {
		if (!section) return;

		destroySlider(section);

		const observer = section.multicolumnResizeObserver;
		if (observer) {
			observer.disconnect();
			delete section.multicolumnResizeObserver;
		}
	};

	const setupSections = (root = document) => {
		root.querySelectorAll('.multicolumn-section').forEach(setupSection);
	};

	setupSections();

	document.addEventListener('shopify:section:load', (event) => {
		if (event.target.classList.contains('multicolumn-section')) {
			setupSection(event.target);
			return;
		}

		setupSections(event.target);
	});

	document.addEventListener('shopify:section:unload', (event) => {
		if (event.target.classList.contains('multicolumn-section')) {
			teardownSection(event.target);
		}
	});
})();
